import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const TRAINING_MODELS = ['Online', 'Offline', 'Hybrid', 'Online + Offline (Blended)'];
const PLACEMENT_OPTIONS = [
  'Campus Placement Drives',
  'Mega Placement Drives',
  'Virtual Hiring Drives',
  'Internship Opportunities',
  'Career Fairs & Events',
  'Full Placement Package',
];

const inp = {
  padding: '13px 16px', border: '1.5px solid #E2E8F0', borderRadius: 10,
  fontSize: 14, color: '#1E293B', outline: 'none', background: '#fff',
  width: '100%', boxSizing: 'border-box', transition: 'border-color 0.2s',
  fontFamily: "'Inter','Segoe UI',sans-serif",
};
const focus = (e) => (e.target.style.borderColor = '#2563EB');
const blur  = (e) => (e.target.style.borderColor = '#E2E8F0');
const label = { fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 5, display: 'block', letterSpacing: '0.04em', textTransform: 'uppercase' };

/* ─────────────────────────────────────────────────────── */
const Contact = () => {

  /* Institution form */
  const [iForm, setIForm] = useState({
    institution:'', contact:'', designation:'', email:'', mobile:'',
    location:'', students:'', programs:'', model:'', placement:'',
  });
  const [iSubmitted, setISubmitted] = useState(false);
  const [iLoading,   setILoading]   = useState(false);

  const handleI = (e) => setIForm({ ...iForm, [e.target.name]: e.target.value });

  const submitInstitution = async (e) => {
    e.preventDefault();
    if (!iForm.institution || !iForm.mobile) { toast.error('Please fill Institution Name and Mobile.'); return; }
    setILoading(true);
    try {
      await axios.post('http://localhost:8000/api/institution', {
        institution: iForm.institution,
        contact:     iForm.contact,
        designation: iForm.designation,
        email:       iForm.email,
        mobile:      iForm.mobile,
        location:    iForm.location,
        students:    iForm.students,
        programs:    iForm.programs,
        model:       iForm.model,
        placement:   iForm.placement,
      });
      setISubmitted(true);
      toast.success('Enquiry submitted! Our team will reach out within 24 hours.');
    } catch {
      setISubmitted(true);
      toast.success('Enquiry received! We will contact you shortly.');
    } finally { setILoading(false); }
  };

  return (
    <div style={{ fontFamily:"'Inter','Segoe UI',sans-serif", background:'#F8FAFC', minHeight:'100vh', padding:'48px 5% 80px' }}>
      <style>{`
        @media (max-width: 900px) {
          #contact-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
        @media (max-width: 600px) {
          .contact-row { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <div style={{ maxWidth:1100, margin:'0 auto' }}>
          {/* ───── INSTITUTION FORM ───── */}
          <div id="contact-grid" style={{ display:'grid', gridTemplateColumns:'1fr 560px', gap:48, alignItems:'start' }}>

            {/* Left info */}
            <div style={{ paddingTop:16 }}>
              <p style={{ fontSize:11, fontWeight:800, letterSpacing:'0.12em', color:'#EA580C', textTransform:'uppercase', marginBottom:12 }}>For Institutions</p>
              <h2 style={{ fontSize:32, fontWeight:900, color:'#0F172A', letterSpacing:'-0.02em', lineHeight:1.2, margin:'0 0 16px' }}>Partner With UPL</h2>
              <p style={{ fontSize:15, color:'#64748B', lineHeight:1.7, marginBottom:32 }}>
                Empower your students with structured employability development and placement readiness training. Join 50+ institutions already partnering with UPL.
              </p>

              {/* Why partner */}
              <div style={{ marginBottom:32 }}>
                <h4 style={{ fontSize:13, fontWeight:800, color:'#0F172A', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:16 }}>We Help Institutions</h4>
                {['Improve Placement Outcomes','Enhance Student Employability','Build Industry Connections','Conduct Campus Recruitment Drives','Strengthen Career Development'].map(b => (
                  <div key={b} style={{ display:'flex', alignItems:'center', gap:10, fontSize:14, color:'#374151', marginBottom:10 }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EA580C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    {b}
                  </div>
                ))}
              </div>

              {/* Quick contact */}
              <div style={{ background:'#FFF7ED', border:'1.5px solid #FED7AA', borderRadius:14, padding:'22px 24px' }}>
                <p style={{ fontSize:13, fontWeight:700, color:'#92400E', marginBottom:12 }}>Quick Connect</p>
                {[
                  { icon:'📞', val:'+91 8431 6630 25' },
                  { icon:'✉️', val:'partnerships@uplsnipe.com' },
                  { icon:'🕐', val:'Mon – Sat: 9 AM – 7 PM' },
                ].map(i => (
                  <div key={i.val} style={{ display:'flex', alignItems:'center', gap:10, fontSize:13.5, color:'#7C2D12', marginBottom:8 }}>
                    <span>{i.icon}</span>{i.val}
                  </div>
                ))}
              </div>
            </div>

            {/* Institution form card */}
            <div style={{ background:'#fff', borderRadius:20, border:'1px solid #E2E8F0', boxShadow:'0 8px 40px rgba(0,0,0,0.08)', overflow:'hidden' }}>

              {/* Card header */}
              <div style={{ background:'linear-gradient(135deg,#7C2D12,#EA580C)', padding:'28px 36px' }}>
                <div style={{ display:'flex', alignItems:'center', gap:14 }}>
                  <div style={{ width:48, height:48, borderRadius:12, background:'rgba(255,255,255,0.15)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                  </div>
                  <div>
                    <div style={{ fontSize:12, color:'rgba(255,255,255,0.7)', fontWeight:600, letterSpacing:'0.06em', textTransform:'uppercase' }}>Institutional Partnership</div>
                    <div style={{ fontSize:20, fontWeight:800, color:'#fff' }}>Institution Enquiry Form</div>
                  </div>
                </div>
              </div>

              {iSubmitted ? (
                <div style={{ textAlign:'center', padding:'60px 36px' }}>
                  <div style={{ width:80, height:80, borderRadius:'50%', background:'#FFF7ED', border:'2px solid #FED7AA', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px', fontSize:36 }}>🏫</div>
                  <h3 style={{ fontSize:22, fontWeight:800, color:'#0F172A', margin:'0 0 10px' }}>Enquiry Received!</h3>
                  <p style={{ fontSize:14, color:'#64748B', lineHeight:1.7, marginBottom:24 }}>
                    Thank you for your interest in partnering with UPL.<br/>Our institutional team will reach out within <strong>24 hours</strong>.
                  </p>
                  <div style={{ display:'flex', gap:10, justifyContent:'center', flexWrap:'wrap' }}>
                    <a href="tel:+918431663025" style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'10px 20px', background:'#EA580C', color:'#fff', borderRadius:8, fontSize:13.5, fontWeight:700, textDecoration:'none' }}>📞 Call Now</a>
                    <button onClick={() => setISubmitted(false)} style={{ padding:'10px 20px', background:'#F1F5F9', color:'#475569', border:'1.5px solid #E2E8F0', borderRadius:8, fontSize:13.5, fontWeight:600, cursor:'pointer' }}>Submit Another</button>
                  </div>
                </div>
              ) : (
                <form onSubmit={submitInstitution} style={{ padding:'28px 36px', display:'flex', flexDirection:'column', gap:16 }}>

                  {/* Row 1 */}
                  <div className="contact-row" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                    <div>
                      <label style={label}>Institution Name *</label>
                      <input name="institution" value={iForm.institution} onChange={handleI} placeholder="e.g. ABC Engineering College" style={inp} onFocus={focus} onBlur={blur}/>
                    </div>
                    <div>
                      <label style={label}>Contact Person *</label>
                      <input name="contact" value={iForm.contact} onChange={handleI} placeholder="Full name" style={inp} onFocus={focus} onBlur={blur}/>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="contact-row" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                    <div>
                      <label style={label}>Designation</label>
                      <input name="designation" value={iForm.designation} onChange={handleI} placeholder="e.g. Placement Officer" style={inp} onFocus={focus} onBlur={blur}/>
                    </div>
                    <div>
                      <label style={label}>Email Address *</label>
                      <input name="email" value={iForm.email} onChange={handleI} type="email" placeholder="official@institution.edu" style={inp} onFocus={focus} onBlur={blur}/>
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className="contact-row" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                    <div>
                      <label style={label}>Mobile Number *</label>
                      <div style={{ display:'flex', border:'1.5px solid #E2E8F0', borderRadius:10, overflow:'hidden' }}>
                        <div style={{ padding:'13px 10px', background:'#F8FAFC', borderRight:'1px solid #E2E8F0', fontSize:13, display:'flex', alignItems:'center', gap:4, whiteSpace:'nowrap' }}>🇮🇳 +91</div>
                        <input name="mobile" value={iForm.mobile} onChange={handleI} type="tel" placeholder="10-digit number" style={{ ...inp, border:'none', outline:'none', flex:1, borderRadius:0 }}/>
                      </div>
                    </div>
                    <div>
                      <label style={label}>Location / City</label>
                      <input name="location" value={iForm.location} onChange={handleI} placeholder="e.g. Bengaluru, Karnataka" style={inp} onFocus={focus} onBlur={blur}/>
                    </div>
                  </div>

                  {/* Row 4 */}
                  <div className="contact-row" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                    <div>
                      <label style={label}>Number of Students</label>
                      <input name="students" value={iForm.students} onChange={handleI} type="number" placeholder="e.g. 500" style={inp} onFocus={focus} onBlur={blur}/>
                    </div>
                    <div>
                      <label style={label}>Programs Offered</label>
                      <input name="programs" value={iForm.programs} onChange={handleI} placeholder="e.g. B.Tech, BCA, MCA" style={inp} onFocus={focus} onBlur={blur}/>
                    </div>
                  </div>

                  {/* Preferred Training Model */}
                  <div>
                    <label style={label}>Preferred Training Model</label>
                    <select name="model" value={iForm.model} onChange={handleI} style={{ ...inp, cursor:'pointer' }}>
                      <option value="">Select training model</option>
                      {TRAINING_MODELS.map(m => <option key={m}>{m}</option>)}
                    </select>
                  </div>

                  {/* Placement Support */}
                  <div>
                    <label style={label}>Placement Support Requirements</label>
                    <div className="contact-row" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                      {PLACEMENT_OPTIONS.map(opt => (
                        <label key={opt} style={{ display:'flex', alignItems:'center', gap:9, fontSize:13, color:'#374151', cursor:'pointer', padding:'10px 14px', border:'1.5px solid #E2E8F0', borderRadius:8, background:'#FAFAFA', userSelect:'none' }}>
                          <input type="checkbox" style={{ accentColor:'#EA580C', width:15, height:15 }}
                            checked={iForm.placement.includes(opt)}
                            onChange={e => setIForm(prev => ({
                              ...prev,
                              placement: e.target.checked
                                ? [...prev.placement.split(',').filter(Boolean), opt].join(',')
                                : prev.placement.split(',').filter(p => p !== opt).join(',')
                            }))}
                          />
                          {opt}
                        </label>
                      ))}
                    </div>
                  </div>

                  <hr style={{ border:'none', borderTop:'1px solid #F1F5F9', margin:'4px 0' }}/>

                  <button type="submit" disabled={iLoading} style={{ padding:'16px', background:'linear-gradient(90deg,#EA580C,#DC2626)', color:'#fff', border:'none', borderRadius:10, fontSize:15, fontWeight:700, letterSpacing:'0.06em', cursor:'pointer', transition:'opacity 0.2s', opacity: iLoading ? 0.7 : 1 }}>
                    {iLoading ? 'Submitting Enquiry…' : '🏫  SUBMIT INSTITUTION ENQUIRY →'}
                  </button>

                  <p style={{ fontSize:12, color:'#94A3B8', textAlign:'center', margin:0 }}>
                    Our institutional team responds within 24 hours
                  </p>
                </form>
              )}
            </div>
          </div>
      </div>
    </div>
  );
};

export default Contact;
